import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

class AccessView extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
  }

  render() {
    const { translate, data } = this.props

    return (
      <div className='padding'>
        <Row className='margin-bottom margin-top'>
          <span className='gray-title'>{translate('analytics.access')}</span>
        </Row>

        <Row className='margin-top-double'>
          <Col xs={4} xsOffset={1}>
            <span className='item-title'>
              {translate('analytics.last30days')}
            </span>
          </Col>
          <Col xs={4} xsOffset={1}>
            <span className='item-title'>
              {translate('analytics.last24hours')}
            </span>
          </Col>
        </Row>

        <Row className='margin-top'>
          <Col xs={4} xsOffset={1}>
            <span className='value'>{data.activeLastMonth}</span>
          </Col>
          <Col xs={1}>|</Col>
          <Col xs={4}>
            <span className='value'>{data.activeLastDay}</span>
          </Col>
        </Row>

        <Row>
          <Col xs={4} xsOffset={1}>
            <span className='item-subtitle'>
              {translate('analytics.actives')}
            </span>
          </Col>
          <Col xs={4} xsOffset={1}>
            <span className='item-subtitle'>
              {translate('analytics.actives')}
            </span>
          </Col>
        </Row>

        <Row className='margin-top'>
          <Col xs={4} xsOffset={1}>
            <span className='value'>{data.inactiveLastMonth}</span>
          </Col>
          <Col xs={1}>|</Col>
          <Col xs={4}>
            <span className='value'>{data.inactiveLastDay}</span>
          </Col>
        </Row>

        <Row>
          <Col xs={4} xsOffset={1}>
            <span className='item-subtitle'>
              {translate('analytics.inactives')}
            </span>
          </Col>
          <Col xs={4} xsOffset={1}>
            <span className='item-subtitle'>
              {translate('analytics.inactives')}
            </span>
          </Col>
        </Row>

        <Row className='margin-top-double filters'>
          <Col xs={2} xsOffset={10}>
            <div className='circular wrap-click' />
          </Col>
        </Row>
      </div>
    )
  }
}

export default AccessView
